import React from 'react'
import Main from '../../Layout/Main'
import Tittle from '../../Components/agenda/Tittle'
import Schedul from '../../Components/agenda/Schedul'
import Clients from '../../Components/agenda/Clients'
import Subscribe from '../../Components/agenda/Subscribe'

const Agenda = () => {
  return (
    <Main>
    <Tittle/>
    <Schedul/>
    <Clients/>
    <Subscribe/>
    </Main>
  )
}

export default Agenda